<template>
  <v-container>
    <list-editor
      :column-keys="columnKeys"
      :items="items"
      :loading="loading"
      :showSearchBar="false"
      :showAddButton="false"
      :showSearchDate="true"
      :showExportButton="false"
      :isFinanceCreditList="false"
      :totalItems="getTotalItems"
      :startDate="startDate"
      :endDate="endDate"
      :sourceName="sourceName"
      :show-select="false"
      @searchData="searchData"
      @handleLoadData="handleLoadData"
    ></list-editor>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ListEditor from "../../components/ListEditor";
import common from '../../mixins/common';

export default {
  name: 'AgentCaseCountView',
  components: {
    ListEditor
  },
  data(){
    return {
      sourceName: "",
      search: {
        keyword: "",
      },
      items: [],
      loading: false,

    };
  },
  mixins:[common],
  created() {
    this.setDefualtDate();
    this.loadData();
  },
  computed: {
    ...mapGetters(["getUserInfo", "getAgentList"]),
    getTotalItems() {
      return this.totalItems;
    },
    columnKeys() {
      let list = [
        {
          value: "vendorName",
          text: "經辦人",
          sortable: true,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "count",
          text: "原融進件量",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "count2",
          text: "商品進件量",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "total",
          text: "總進件量",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: true,
        },
      ];
      return list;
    },
  },
  methods: {
    ...mapActions(['getAgentCaseCountList'
      ]),
    setDefualtDate() {
      let todayDate = new Date();
      let currentDate = todayDate.toISOString().substr(0, 10);
      const [thisYear, thisMonth, thisDay] = currentDate.split("-");
      this.startDate = `${thisYear}-${thisMonth}-${thisDay}`;
      this.endDate = `${thisYear}-${thisMonth}-${thisDay}`;
    },
    async loadData() {
      this.loading = true;
      const results = await this.getAgentCaseCountList({
        agentId: '',
        startDate: `${this.startDate} 00:00:00`,
        endDate: `${this.endDate} 23:59:59`,
      });
      this.items = results.data.data.list;
      this.totalItems = results.data.data.header.totalCount;
      this.loading = false;
      console.log(`items === ${JSON.stringify(this.items)}`);
    },
    searchData(searchInfo) {
      console.log(`searchData == ${JSON.stringify(searchInfo)}`)
      this.searchKey = searchInfo.searchKey;
      this.startDate = searchInfo.startDate;
      this.endDate = searchInfo.endDate;
      this.searchValue = searchInfo.keyword;
      this.loadData();
    },
    handleLoadData() {
      this.loadData()
    }

  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/web/AgentCaseCountView.vue